import moment from 'moment';
import React, { useState, useEffect, useContext } from 'react';
import useCallApi from '../../hooks/useCallApi';
import ScrollToBottom from '../../hoc/ScrollToBottom/ScrollToBottom';
import { SystemMessageContext } from '../../context/SystemMessageContext';
import callAPI from '../../helpers/callAPI';
import TextareaImage from '../TextareaImage/TextareaImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const maxLogLength = 500

export default function NotesLog({ isIssue, pitchStatus, isPitch, uri, id, refresh = false, postAsFollowupOption = false, fixedHeight = true, advertiserId, extraNotes = false, metWithDefault = false, refetchNotesParent = false }) {

    const { showSystemMessage } = useContext(SystemMessageContext)

    const { dataLoaded, data, refetch } = useCallApi(`${uri}/${id}/log`, 'GET', {}, [id])

    const [logLength, setLogLength] = useState(0)
    const [preview, setPreview] = useState(false)
    const [file, setFile] = useState(false)
    const [logText, setLogText] = useState('')
    const [postAsFollowup, setPostAsFollowup] = useState(false)
    const [metWith, setMetWith] = useState('')

    const processExtraNotes = (notes) => {
        if (!notes) return '';
        return notes.replace(/-{3,}/g, '<br />---------------<br />');
    }

    useEffect(() => {
        refetch()
    }, [refresh])

    const saveLog = () => {
        let hasError = false

        if (!logText.trim()) {
            showSystemMessage('error', 'The notes field is required')
            hasError = true
        }
        if (!metWith.toString().trim() && metWithDefault) {
            showSystemMessage('error', 'The met with field is required')
            hasError = true
        }
        if (!hasError) {
            const formData = new FormData()
            let tempLogText = logText
            let advertiserFollowupNote = logText
            //add met with to logText if it exists
            if (metWithDefault) {
                tempLogText = `Met With: ${metWith}\n${tempLogText}`
                advertiserFollowupNote = `Met With: ${metWith}\n${advertiserFollowupNote}`
            }
            if (postAsFollowup && isIssue) {
                advertiserFollowupNote += `\n\n<a href="${process.env.REACT_APP_PORTAL_URL}/issue/${id}" target="_blank">View Issue</a>`
            }
            formData.append('file', file)
            formData.append('log', tempLogText)
            formData.append('postAsFollowup', postAsFollowup)
            formData.append('followupNote', tempLogText)
            formData.append('advertiserFollowupNote', advertiserFollowupNote)
            formData.append('advertiserId', advertiserId || 0)
            let createFollowup = false
            // console.log(pitchStatus, data.log?.length, isPitch);
            if ((pitchStatus && pitchStatus.code == 'D' || (data.log?.length === 0 && isPitch))) {
                createFollowup = true
                formData.append('createFollowup', createFollowup)
                formData.append('results', 'OT')
            }

            callAPI(`${uri}/${id}/log`, 'POST', formData, true)
                .then((result) => {
                    if (result['success'] === true) {
                        refetch()
                        if (refetchNotesParent) {
                            refetchNotesParent()
                        }
                    } else if (result['success'] === false) {
                        showSystemMessage('error', result.errors.message)
                        refetch()
                        if (refetchNotesParent) {
                            refetchNotesParent()
                        }
                    }
                    //reset the textarea
                    setLogText('')
                    setMetWith('')
                    setFile(false)
                    setPreview(false)
                    setLogLength(0)
                    setPostAsFollowup(false)
                })
                .catch((error) => {
                    showSystemMessage('error', `Error while saving campaign request: ${error.message}`)
                })
        }
    }

    return (
        <div className='card mb-3'>
            <div className="card-header">
                <h1 className="mb-h1-dark">Log</h1>
            </div>
            <div className='card-body p-0'>
                <div style={{
                    backgroundColor: 'rgba(0,0,0,.03)',
                    height: fixedHeight ? '200px' : '400px',
                    maxHeight: fixedHeight ? '200px' : '400px',
                    flexDirection: 'column',
                    overflowY: 'auto'
                }} className="p-2 border-bottom">
                    {(dataLoaded) ?
                        extraNotes && extraNotes.length <= 0 && data.log && data.log.length <= 0 ?
                            <div className="text-secondary">No notes.</div>
                            :
                            <>
                                {extraNotes && (
                                    <div dangerouslySetInnerHTML={{ __html: processExtraNotes(extraNotes) }} />
                                )}
                                {(data.log && data.log.length > 0) &&
                                    data.log.map(item => {
                                        return (
                                            <div>

                                                <div>
                                                    <span className="font-weight-bold">{moment(item.db_date).utc().format('YYYY-MM-DD HH:mm')}</span>
                                                    <span className="text-secondary ml-3">{item.full_name}</span>
                                                </div>
                                                <div>
                                                    <span style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: item.notes }} />
                                                    {item.image &&
                                                        <div className="mt-2" style={{ height: '100px' }}>
                                                            <a target="_blank" href={item.image}>
                                                                <img src={item.image} className="border rounded" style={{ maxHeight: '100px' }} alt="Request image" crossOrigin={process.env.REACT_APP_PORTAL_URL} />
                                                            </a>
                                                        </div>
                                                    }
                                                    {item.file &&
                                                        <div className="mt-2">
                                                            <div className="alert alert-secondary d-inline-block m-0"><a target="_blank" href={item.file}>📄 Download File</a></div>
                                                        </div>
                                                    }
                                                </div>
                                                <hr />
                                            </div>
                                        )
                                    })
                                }
                            </>
                        :
                        <div className="text-secondary"><FontAwesomeIcon icon="spinner" spin /> Loading...</div>
                    }
                    <ScrollToBottom />
                </div>
                <div className="p-2">
                    <form>
                        <TextareaImage
                            metWith={metWith}
                            metWithDefault={metWithDefault}
                            setMetWith={setMetWith}
                            name="log"
                            required={true}
                            maxLength={maxLogLength}
                            preview={preview}
                            setPreview={setPreview}
                            setFile={setFile}
                            setLength={setLogLength}
                            advertiserId={advertiserId}
                            postAsFollowupOption={postAsFollowupOption}
                            value={logText}
                            onChange={(e) => setLogText(e.target.value)}
                            onPostAsFollowupChange={(e) => setPostAsFollowup(e.target.checked)}
                            postAsFollowup={postAsFollowup}
                        />
                        <div className="justify-content-end mt-2 d-flex align-items-center">
                            <span className="text-secondary mr-2">{maxLogLength - logLength}</span>
                            <button className="btn btn-primary" type="button" onClick={saveLog}>Save Note</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}